import { AssertHomey } from '../../../../util/decorators';

export const zones = {
	namespaced: true,

	state: {
		zones: null,
		subscribed: false,
	},

	getters: {
		all(store){
			return store.zones;
		},
	},

	mutations: {
		setZones(state, { zones, subscribe }){
			state.zones = zones;
			if(!state.subscribed) {
    			state.subscribed = true;
    			subscribe();
			}
		},
		clearAll(state){
			state.zones = null;
            state.subscribed = false;
		}
	},

	actions: {
		@AssertHomey()
		retrieveAll({ commit, homeyAPI }){
    		    		
    		let refresh;
    		
    		let subscribe = () => {
        		homeyAPI.zones.on('zone.update', refresh);
        		homeyAPI.zones.on('zone.create', refresh);
        		homeyAPI.zones.on('zone.delete', refresh);
    		};
    		
    		refresh = async () => {
                let zones = await homeyAPI.zones.getZones()
				commit('setZones', { zones: Object.values(zones), subscribe });
    		};
    		
    		refresh();
		},
		clearAll({ commit }){
			commit('clearAll');
		}
	},

	plugins: [
		// (store) => {
		//   cloudAPI.on('logout', () => store.commit('api/logOut'));
		//   cloudAPI.on('token', (token) => store.commit('api/setToken', { token }));
		//
		//   const { token } = store.state.api;
		//   if (token) {
		//     store.dispatch('api/logIn', { token });
		//   }
		// },
	],
};
